module.exports = __webpack_public_path__ + "static/media/spot24.a6d07672.webp";